import { extractStringValueSet } from './extract-properties';

/**
 * Lists coverage options for Sequence Isolate order items
 */
export default class ItemCoverage {

    static readonly High: string = 'high';
    static readonly Low: string = 'low';

    private static _valueSet: Set<string> = null;
    static get values(): Set<string> {

        if (!this._valueSet) {
            this._valueSet = new Set();
            this._valueSet = extractStringValueSet(this);
        }

        return new Set(this._valueSet);
    }
}
